<template>
  <div class="my-schedule">
    <page-header title="我的课表" :data="pageHeaderArr" />
    <el-tabs v-model="activeName">
      <el-tab-pane v-for="pitem in EETabsData" :key="pitem.id" :label="pitem.name" :name="pitem.id + ''">
        <div class="project-status">
          <el-tag effect="plain">{{ pitem.status }}</el-tag>
        </div>

        <ming-table v-model="data" v-loading="loading" :fields="column">
          <template #week="{ scope }">
            <span v-if="scope.startWeek">{{ scope.startWeek }}&nbsp;~&nbsp;{{ scope.endWeek }}周</span>
            <span v-else>-</span>
          </template>
          <template #assistantTeacher="{ scope }">
            <div v-for="item in scope.assistantTeacher" :key="item.mobile" style="text-align: center">
              <p>{{ item.name }}</p>
              <p>电话：{{ item.mobile }}</p>
              <p>电话：{{ item.email }}</p>
            </div>

            <span v-if="!scope.assistantTeacher">-</span>
          </template>
          <template #reason="{ scope }">
            <el-button v-if="+scope.hasStop === 1" type="text" @click="getCourseDialog('stop', scope.id)">查看</el-button>
            <span v-else>-</span>
          </template>
          <template #hasExtra="{ scope }">
            <el-button v-if="+scope.hasExtra === 1" type="text" @click="getCourseDialog('extra', scope.id)">查看</el-button>
            <span v-else>-</span>
          </template>
          <template #hasChange="{ scope }">
            <el-button v-if="+scope.hasChange === 1" type="text" @click="getCourseDialog('change', scope.id)">查看</el-button>
            <span v-else>-</span>
          </template>
          <template #options="{ scope }">
            <el-button type="text" @click="getCourseDialog('down', scope.courseId)">课程资料</el-button>
            <el-button type="text" @click="getCourseDialog('time', scope.id)">查看上课时间</el-button>
            <!-- <el-button type="text">查看考勤</el-button> -->
          </template>
        </ming-table>
      </el-tab-pane>
    </el-tabs>

    <course-time-dialog v-if="CourseTimeVisible" :visible.sync="CourseTimeVisible" :type="CourseType" :course-id="CourseID" />
  </div>
</template>

<script setup>
import PageHeader from '@/components/PageHeader'
import { EEScheduleTable } from '../tableColumn'
import { ref, onMounted } from 'vue'
import CourseTimeDialog from '../components/CourseTimeDialog.vue'
import API from '@/api'

const loading = ref(false)

const pageHeaderArr = ref([
  {
    title: '学年',
    value: ''
  },
  {
    title: '学期',
    value: ''
  },
  {
    title: '教学周',
    value: ''
  }
])

const column = ref(EEScheduleTable)
const data = ref([])
// 获取我的课表table数据
function getCourseTable(params) {
  loading.value = true
  API.EECourseTable(params)
    .then(res => {
      if (+res.code === 200) {
        data.value = res.data || []
        loading.value = false
      } else {
        loading.value = false
      }
    })
    .catch(_ => {
      loading.value = false
    })
}

/* 获取当前学年、学期、周数 */
function getSchoolCalendar() {
  API.Semester().then(res => {
    if (+res.code === 200) {
      const { semester, schoolYear, week } = res.data
      const data = [
        {
          title: '学年',
          value: schoolYear || '-'
        },
        {
          title: '学期',
          value: semester || '-'
        },
        {
          title: '教学周',
          value: week ? `第${week}周` : '-'
        }
      ]
      pageHeaderArr.value = data
    }
  })
}

const CourseTimeVisible = ref(false)
const CourseID = ref(null)
const CourseType = ref('')
// 打开课程弹窗
function getCourseDialog(type, courseId) {
  CourseTimeVisible.value = true
  CourseID.value = courseId
  CourseType.value = type
}

/* EE tabs 数据 */
const activeName = ref(null)
const EETabsData = ref([])
function getEEProject() {
  API.EEProject().then(res => {
    if (+res.code === 200 && res.data !== null) {
      activeName.value = res.data[0].id + ''
      EETabsData.value = res.data
      getCourseTable({ projectId: res.data[0].id })
    }
  })
}

onMounted(() => {
  getSchoolCalendar()
  getEEProject()
})
</script>

<style lang="scss" scoped>
p {
  margin: 0;
}
.my-schedule-table {
  margin-top: 20px;
}
.project-status {
  margin-bottom: 10px;
}
.line {
  margin-top: 100px;
  position: relative;
  width: 100%;
  height: 1px;
  background-color: #000;
  &::before {
    content: attr(labelName);
    position: absolute;
    top: 50%;
    left: 0;
    display: block;
    width: auto;
    height: 20px;
    margin-top: -10px;
    padding-right: 20px;
    background-color: #fff;
  }
}
</style>
